import { GenericSuggestion } from 'types/suggestions/CoreSuggestions';
import { LoadBuildingSuggestions } from 'types/suggestions/LoadBuildingSuggestions';

import { PartitionedLoadBuildingSuggestions } from '../types';
import {
  isBuiltLoadBuildingSuggestion,
  isLoadBuildingSuggestion,
} from './isBuiltLoadBuildingSuggestion';

// Splits the thread's load building cards into open and built, keeping the API's first-seen order.
export function partitionLoadBuildingSuggestions(
  suggestions: GenericSuggestion[]
): PartitionedLoadBuildingSuggestions {
  const open: LoadBuildingSuggestions[] = [];
  const built: LoadBuildingSuggestions[] = [];

  for (const suggestion of suggestions) {
    if (isBuiltLoadBuildingSuggestion(suggestion)) {
      built.push(suggestion);
    } else if (isLoadBuildingSuggestion(suggestion)) {
      open.push(suggestion);
    }
  }

  return { open, built };
}
